"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingFactory = void 0;
const CheckoutRequestHandler_1 = require("../requestHandlers/CheckoutRequestHandler");
class ShippingFactory {
    /**
     * Gets all available shipping options for this checkout
     * @param {number} shopId
     * @param {string} checkoutId
     * @returns {Promise<IGetCheckoutShippingOptionsData[]>}
     */
    static getShippingOptions(shopId, checkoutId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CheckoutRequestHandler_1.CheckoutRequestHandler.getShippingOptions(shopId, checkoutId);
        });
    }
    /**
     * fill existing checkout with shipping data
     * @param {number} shopId
     * @param {string} checkoutId
     * @param {ICheckoutPutParams} payload
     * @returns {Promise<ICheckoutData>}
     */
    static setShippingOptions(shopId, checkoutId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return CheckoutRequestHandler_1.CheckoutRequestHandler.putParams(shopId, checkoutId, payload);
        });
    }
}
exports.ShippingFactory = ShippingFactory;
